module.exports = __webpack_public_path__ + "static/media/Fresh_Honey_TH.de3d7972.png";